/**
 * Listado centralizado de permisos del sistema Surtimotos.
 * Cada módulo tiene su propio bloque de permisos únicos.
 */
export const PERMISSIONS = {
    // PANEL E INDICADORES
    PANEL: {
        VIEW: "PANEL_VIEW",
    },
    INDICADORES: {
        VIEW: "INDICADORES_VIEW",
    },
    // PRODUCTOS
    PRODUCTOS: {
        VIEW: "PROD_VIEW",
        CREATE: "PROD_CREATE",
        EDIT: "PROD_EDIT",
        DELETE: "PROD_DELETE",
    },
    // PEDIDOS (Ventas y Clientes)
    PEDIDOS: {
        VIEW: "ORD_VIEW",
        CREATE: "ORD_CREATE",
        MANAGE: "ORD_MANAGE", // Gestión de pedidos (Aprobar, Preparar, etc)
        DELETE: "ORD_DELETE",
    },
    // CLIENTES
    CLIENTES: {
        VIEW: "CLIENTE_VIEW",
        CREATE: "CLIENTE_CREATE",
        EDIT: "CLIENTE_EDIT",
        DELETE: "CLIENTE_DELETE",
    },
    // PROVEEDORES
    PROVEEDORES: {
        VIEW: "PROV_VIEW",
        CREATE: "PROV_CREATE",
        EDIT: "PROV_EDIT",
        DELETE: "PROV_DELETE",
    },
    // GESTIÓN DE COMPRAS (ALMACÉN PRINCIPAL)
    COMPRAS: {
        PEDIDOS: "COMPRAS_PEDIDOS",
        RECEPCION: "COMPRAS_RECEPCION",
        VERIFICACION: "COMPRAS_VERIFICACION",
        TRANSFERENCIA: "COMPRAS_TRANSFERENCIA",
    },
    // RED ALIADA (Tiendas retail)
    RED_ALIADA: {
        VIEW: "RED_ALIADA_VIEW",
        CREATE: "RED_ALIADA_CREATE",
        EDIT: "RED_ALIADA_EDIT",
        DELETE: "RED_ALIADA_DELETE",
    },
    // VENTAS RETAIL (POS Vitrina)
    VENTAS_RETAIL: {
        VIEW: "VENTA_RETAIL_VIEW",
        CREATE: "VENTA_RETAIL_CREATE",
        EDIT: "VENTA_RETAIL_EDIT",
        ANULAR: "VENTA_RETAIL_ANULAR",
        COMANDA: "VENTA_RETAIL_COMANDA",
        CAJA: "VENTA_RETAIL_CAJA",
        EN_VIVO: "VENTA_RETAIL_EN_VIVO",
    },
    // NOTAS DE CRÉDITO (Devoluciones)
    NOTAS_CREDITO: {
        VIEW: "NOTA_CREDITO_VIEW",
        CREATE: "NOTA_CREDITO_CREATE",
        CONFIRMAR: "NOTA_CREDITO_CONFIRMAR",
    },
    // GESTIÓN FINANCIERA
    PAGOS: {
        APPROVE: "PAY_APPROVE",
        HISTORY: "PAY_HISTORY",
    },
    // ALMACENES Y LOGÍSTICA
    ALMACENES: {
        VIEW: "ALMACEN_VIEW",
        CREATE: "ALMACEN_CREATE",
        EDIT: "ALMACEN_EDIT",
        DELETE: "ALMACEN_DELETE",
        TRASLADOS_VIEW: "TRASLADO_VIEW",
        TRASLADOS_CREATE: "TRASLADO_CREATE",
        TRASLADOS_DELETE: "TRASLADO_DELETE",
    },
    // MANTENIMIENTO: REPUESTOS
    REPUESTOS: {
        VIEW: "REPUESTO_VIEW",
        CREATE: "REPUESTO_CREATE",
        EDIT: "REPUESTO_EDIT",
        DELETE: "REPUESTO_DELETE",
    },
    // MANTENIMIENTO: EQUIVALENTES
    EQUIVALENTES: {
        VIEW: "EQUIVALENTE_VIEW",
        CREATE: "EQUIVALENTE_CREATE",
        EDIT: "EQUIVALENTE_EDIT",
        DELETE: "EQUIVALENTE_DELETE",
    },
    // USUARIOS
    USUARIOS: {
        VIEW: "USER_VIEW",
        CREATE: "USER_CREATE",
        EDIT: "USER_EDIT",
        DELETE: "USER_DELETE",
    },
    // ROLES
    ROLES: {
        VIEW: "ROLE_VIEW",
        MANAGE: "ROLE_MANAGE",
    },
    // CONFIGURACIÓN (MANTENIMIENTO)
    CONFIGURACION: {
        DESPLEGABLES_VIEW: "CONFIG_DESPLEGABLES_VIEW",
        DESPLEGABLES_MANAGE: "CONFIG_DESPLEGABLES_MANAGE",
        DEPARTAMENTOS_VIEW: "CONFIG_DEPARTAMENTOS_VIEW",
        DEPARTAMENTOS_MANAGE: "CONFIG_DEPARTAMENTOS_MANAGE",
        CATEGORIAS_VIEW: "CONFIG_CATEGORIAS_VIEW",
        CATEGORIAS_MANAGE: "CONFIG_CATEGORIAS_MANAGE",
        INSTRUMENTOS_PAGO_VIEW: "CONFIG_PAGOS_VIEW",
        INSTRUMENTOS_PAGO_MANAGE: "CONFIG_PAGOS_MANAGE",
        SISTEMA_VIEW: "CONFIG_SISTEMA_VIEW",
        SISTEMA_MANAGE: "CONFIG_SISTEMA_MANAGE",
    },
    // PRECIOS, VENTAS Y PROMOCIONES AUTOMATIZADAS
    PRECIOS: {
        VIEW: "PRECIOS_VIEW", // Ver la grilla, costos, precios calculados y métrica PVD
        EDIT: "PRECIOS_EDIT", // Editar % utilidad detal, % mayor global y configuración
        PROMO: "PRECIOS_PROMO", // Crear, editar y eliminar promociones temporales
    },
};
// Helper para obtener todos los valores (códigos) en un array simple si fuera necesario
export const ALL_PERMISSION_CODES = Object.values(PERMISSIONS).flatMap((group) => Object.values(group));
